<div container-principal>
    <header>
        <button (click)="fecharModal()">
            <object data="assets\agview-connect\Arrow-left.svg" type="image/svg+xml">{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_SELECAO.ARROW" | transloco }}</object>
        </button>
        <span class="font-13 fw-bold">
            {{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_SELECAO.SELECTION_OF" | transloco }} 
            {{ (configs.item == 'controle' ? configs.item : configs.tipoConfig).toUpperCase() }} 
            {{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_SELECAO.DE" | transloco }} 
            {{ configs.nomeConfig.toUpperCase() }}
        </span>
    </header>
    <article class="w-100 d-flex justify-content-center">
        <div conteudo>
            <ul class="d-flex flex-column justify-content-center gp-05">
                @for (item of configs.disponiveis; track item;let i = $index) {
                <li class="d-flex align-items-center gp-05">
                    <span>
                        {{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_SELECAO.CONTROLADORA" | transloco }} 
                        {{ configs.disponiveis.length > 1 ? i + 2 : i + 1 }}
                    </span>
                    @for (controladora of item; track controladora;) {
                    <button (click)="alternarControladoraSensor(controladora)"
                        [class.indisponivel]="controladoresSensoresEmUso.includes(controladora)"
                        [class.active]="itensSelecionados.includes(controladora)">{{controladora}}</button>
                    }
                </li>
                }
            </ul>
        </div>
    </article>
    <footer class="d-flex flex-column w-100">
        <span class="info-popup mx-auto">
            {{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_SELECAO.SELECT_UP_TO" | transloco }} 
            {{ configs.quantMax }} 
            {{ configs.quantMax > 1 ? configs.tipoConfig : configs.item }}
        </span>
        <span [hidden]="!contraladorSelecionadoEmUso" class="info-popup alerta mx-auto">
            {{ controladorEmUso }} {{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_SELECAO.ALREADY_IN_USE" | transloco }}
        </span>
        <button (click)="enviarDados()">
            <object data="assets\agview-connect\check.svg" type="image/svg+xml">Check</object>
            <span>{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_SELECAO.CONFIRM" | transloco }}</span>
        </button>
    </footer>
</div>